import React from 'react';
import {CircularProgress} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import CommonDetail from "../Common/CommonDetail";
import withRouter from "../../utils/withRouter";

// internal components
import EmployeeDetailHeader from "./EmployeeDetailHeader";
import EmployeePositionList from "./EmployeePositionList";
import EmployeeDetailBonusList from "./EmployeeDetailBonusList";

// icons
import WorkIcon from '@mui/icons-material/Work';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AttachmentsTab from "../Attachment/AttachmentsTab";


class EmployeeDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employee: null,
            positions: null,
            bonuses: null,
            ready: false,
        };
    }

    async componentDidMount() {
        await this.retrieveData();
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.params.employeeId !== this.props.params.employeeId) {
            await this.retrieveData();
        }
    }

    async retrieveData() {
        this.setState({ employee: null, positions: null, bonuses: null, ready: false });
        const api = new BaseApi();
        const employeeId = this.props.params.employeeId;

        try {
            const empRes = await api.get(`employee/${employeeId}/`, {});

            this.setState({
                employee: empRes.data,
                positions: [],
                bonuses: [],
                ready: true
            });
        } catch (error) {
            console.error("Error fetching employee data", error);
            this.setState({ ready: true, employee: null }); 
        }
    }

    render() {
        if (!this.state.ready) {
            return <CircularProgress />;
        }
        
        if (!this.state.employee) {
            return (
                <div style={{padding: 20, textAlign: 'center'}}>
                    Сотрудник не найден
                </div>
            );
        }

        return (
            <CommonDetail
                appName={'Employee'}
                appId={this.state.employee.id}
                header={{
                    component: EmployeeDetailHeader,
                    componentProps: {
                        employee: this.state.employee,
                        callBack: this.retrieveData.bind(this),
                        params: this.props.params
                    },
                    leftOverflow: {
                        icon: null,
                        title: 'Сотрудник',
                        color: 'primary'
                    },
                }}
                defaultTabValue={'positions'}
                tabComponents={[
                    {
                        title: 'Должности',
                        value: 'positions',
                        icon: WorkIcon,
                        component: <EmployeePositionList
                            employee={this.state.employee}
                        />,
                    },
                    {
                        title: 'Премии',
                        value: 'bonuses',
                        icon: AttachMoneyIcon,
                        component: <EmployeeDetailBonusList
                            employee={this.state.employee}
                        />,
                    },
                    {
                        title: 'Вложения',
                        value: 'attachment',
                        icon: AttachFileIcon,
                        component: <AttachmentsTab 
                            appId={this.state.employee.id} 
                            appName={'Employee'} 
                        />,
                    },
                ]}
            />
        );
    }
}

export default withRouter(EmployeeDetail);